import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import { toast } from "react-toastify";
import cities from "../POS/cities.json";
import countries from "../POS/countries.json";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateZone } from "UpdatedFeatures/api";

const EditZoneModal = ({ open, setOpen, zone }) => {
  console.log(zone);
  console.log(countries);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [locations, setLocations] = useState([
    { city: "", street_address: "" },
  ]);
  console.log(locations);
  const queryClient = useQueryClient();

  const updateZoneMutation = useMutation({
    mutationFn: ({ id, data }) => updateZone(id, data),
    onSuccess: () => {
      toast.success("Zone mise à jour avec succès");
      queryClient.invalidateQueries(["zones"]);
      setOpen(false);
    },
    onError: (error) => {
      toast.error(
        `Erreur lors de la mise à jour de la zone : ${error.message}`
      );
    },
  });
  function convertUnicodeToEmoji(unicode) {
    return unicode
      .split(" ")
      .map((u) => String.fromCodePoint(parseInt(u.replace("U+", ""), 16)))
      .join("");
  }
  useEffect(() => {
    if (zone) {
      const country = countries.find((c) => c.name_fr === zone.country);
      setSelectedCountry(country?.id || "");

      // Normalize location keys
      const normalizedLocations = zone.locations?.length
        ? zone.locations.map((loc) => ({
            city: loc.city || loc.city_name || "",
            street_address: loc.street_address || loc.street_address || "",
          }))
        : [{ city: "", street_address: "" }];

      setLocations(normalizedLocations);
    }
  }, [zone]);

  const handleLocationChange = (index, field, value) => {
    setLocations((prev) =>
      prev.map((loc, i) => (i === index ? { ...loc, [field]: value } : loc))
    );
  };

  const handleAddLocation = () => {
    setLocations((prev) => [...prev, { city: "", street_address: "" }]);
  };

  const handleRemoveLocation = (index) => {
    if (locations.length > 1) {
      setLocations((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !selectedCountry ||
      locations.some((loc) => !loc.city || !loc.street_address)
    ) {
      toast.error("Tous les champs sont requis");
      return;
    }

    const countryName =
      countries.find((c) => c.id === Number(selectedCountry))?.name_fr || "";

    updateZoneMutation.mutate({
      id: zone.id,
      data: {
        country: countryName,
        locations,
      },
    });
  };

  const sortedCountries = [...countries].sort((a, b) =>
    a.name_fr.localeCompare(b.name_fr)
  );
  const availableCities = selectedCountry
    ? cities.filter((city) => city.stateId === String(selectedCountry))
    : [];

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50" style={{ zIndex: 9990 }}>
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={() => setOpen(false)}
      />
      <div className="flex items-center justify-center min-h-screen p-4 overflow-y-auto">
        <div
          className="relative w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden max-h-[calc(100vh-4rem)] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center px-6 py-4 bg-[#b269ae] text-white">
            <h3 className="text-lg font-medium">Modifier la zone</h3>
            <button
              onClick={() => setOpen(false)}
              className="hover:scale-110 duration-200"
            >
              <RiCloseLine className="w-6 h-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-4 space-y-6">
            <div
              onClick={() =>
                toast.warn("Vous ne pouvez pas modifier le pays d’un entrepôt")
              }
            >
              <label className="block text-sm font-medium text-gray-700">
                Pays
              </label>
              <select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                className="mt-1 w-full h-12 px-3 rounded-md disabled:cursor-not-allowed border border-gray-300 shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                required
                disabled
              >
                <option value="">Sélectionner un pays</option>
                {sortedCountries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {convertUnicodeToEmoji(country.emojiU)} {country.name_fr}
                  </option>
                ))}
              </select>
            </div>

            {locations.map((location, index) => (
              <div key={index} className="border-t pt-4">
                <div className="text-sm font-semibold text-gray-700 mb-2">
                  Localisation {index + 1}
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Ville
                  </label>
                  <input
                    type="text"
                    value={location.city}
                    onChange={(e) =>
                      handleLocationChange(index, "city", e.target.value)
                    }
                    className="mt-1 w-full h-12 px-3 rounded-md border border-gray-300 shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Adresse
                  </label>
                  <input
                    type="text"
                    value={location.street_address}
                    onChange={(e) =>
                      handleLocationChange(
                        index,
                        "street_address",
                        e.target.value
                      )
                    }
                    className="mt-1 w-full h-12 px-3 rounded-md border border-gray-300 shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                    required
                  />
                </div>

                {locations.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveLocation(index)}
                    className="mt-2 text-sm text-red-500 hover:text-red-700"
                  >
                    - Supprimer cette localisation
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={handleAddLocation}
              className="text-sm text-[#b269ae] hover:text-[#9c58a3]"
            >
              + Ajouter une autre localisation
            </button>

            <div className="flex justify-end gap-4 pt-4">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={updateZoneMutation.isPending}
                className="px-4 py-2 bg-[#b269ae] text-white rounded-md hover:bg-[#9c58a3] disabled:opacity-50"
              >
                {updateZoneMutation.isPending
                  ? "Enregistrement..."
                  : "Enregistrer"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditZoneModal;
